import React, { useState } from 'react';
import { StreamChat } from 'stream-chat';
import { Chat } from 'stream-chat-react';
import Cookies from 'universal-cookie';
import { ChannelContainer, ChannelListContainer, Auth } from './components';
import 'stream-chat-react/dist/css/index.css'; //inbuilt css in react for easier styling
import './App.css';

const cookies = new Cookies();

const apiKey='f6xg84ymvjm7';
const authToken = cookies.get("token"); //authToken will be available only if the user is logged in
const client = StreamChat.getInstance(apiKey); //creating instance of Chat and passing it as client param

if(authToken){ //if authtoken is there, then create a user
  client.connectUser({
        id: cookies.get('userId'), //these id, name.. should be exactly named as it is here coz they are stored in connectUser(getStream - Chat - ecxplore - userdetails) like that
        name: cookies.get('username'),
        image: cookies.get('avatarURL'),
        fullName: cookies.get('fullName'),
        phoneNumber: cookies.get('phoneNumber'),
        hashedPassword: cookies.get('hashedPassword'),
  }, authToken) 
} //with this, we can connect to our user and get all of his messages

const App = () => {
//creating these states here coz we need these both in Channellistcontainer and channelcontainer
  const [createType, setCreateType] = useState(''); 
  const [isCreating, setIsCreating] = useState(false);
  const [isEditing, setIsEditing] = useState(false);

  if (!authToken) return <Auth />; 
  //if there's no authToken, then auth comp will be rendered. Eveything we did below is gonna be hidden
  return (
        <div className='app__wrapper' theme="team light"> {/* team light theme is inbuilt */}
            <Chat client={client}>
                <ChannelListContainer 
                    isCreating={isCreating}
                    setIsCreating={setIsCreating}
                    setCreateType={setCreateType}
                    setIsEditing={setIsEditing}
                />
                <ChannelContainer 
                    isCreating={isCreating}
                    setIsCreating={setIsCreating}
                    isEditing={isEditing}
                    setIsEditing={setIsEditing}
                    createType={createType}
                    />
            </Chat>
        </div>
  )
};

export default App;
